
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"-8 0 62 47","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M.58 11.645L23.5 0l22.921 11.645c.992.525.626 1.994-.47 1.994h-2.088v2.098a1.05 1.05 0 01-1.044 1.049H4.18a1.05 1.05 0 01-1.044-1.05V13.64H1.05c-1.097 0-1.462-1.47-.47-1.994zm45.375 29.48H1.045c-.575 0-1.045.44-1.045.98V47h47v-4.896c0-.538-.47-.979-1.045-.979zM10.426 19.304H5.681c-.316 0-.527.203-.527.508v13.715H3.572c-.58 0-1.054.457-1.054 1.016v4.064h41.125v-4.064c0-.559-.475-1.016-1.055-1.016h-1.581V19.812c0-.305-.211-.508-.528-.508h-4.745c-.316 0-.527.203-.527.508v13.715h-4.218V19.812c0-.305-.21-.508-.527-.508h-4.745c-.317 0-.528.203-.528.508v13.715h-4.218V19.812c0-.305-.21-.508-.527-.508h-4.745c-.316 0-.527.203-.527.508v13.715h-4.218V19.812c0-.305-.211-.508-.528-.508z","fill":"currentColor"}})])
          )
        }
      }
    